"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    login: {
        path: "/login"
    },
    provideCredentials: {
        path: "/provide-credentials"
    },
    logout: {
        path: "/logout"
    },
    adminLogin: {
        path: "/admin/login"
    },
    adminAccounts: {
        path: "/admin/accounts"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvc2Vzc2lvbnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBsb2dpbjoge1xuICAgIHBhdGg6IFwiL2xvZ2luXCIsXG4gIH0sXG4gIHByb3ZpZGVDcmVkZW50aWFsczoge1xuICAgIHBhdGg6IFwiL3Byb3ZpZGUtY3JlZGVudGlhbHNcIixcbiAgfSxcbiAgbG9nb3V0OiB7XG4gICAgcGF0aDogXCIvbG9nb3V0XCIsXG4gIH0sXG4gIGFkbWluTG9naW46IHtcbiAgICBwYXRoOiBcIi9hZG1pbi9sb2dpblwiLFxuICB9LFxuICBhZG1pbkFjY291bnRzOiB7XG4gICAgcGF0aDogXCIvYWRtaW4vYWNjb3VudHNcIixcbiAgfSxcbn0pO1xuIl0sIm5hbWVzIjpbInJvdXRlcyIsImJ1aWxkUm91dGVzIiwibG9naW4iLCJwYXRoIiwicHJvdmlkZUNyZWRlbnRpYWxzIiwibG9nb3V0IiwiYWRtaW5Mb2dpbiIsImFkbWluQWNjb3VudHMiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxPQUFPO1FBQ0xDLE1BQU07SUFDUjtJQUNBQyxvQkFBb0I7UUFDbEJELE1BQU07SUFDUjtJQUNBRSxRQUFRO1FBQ05GLE1BQU07SUFDUjtJQUNBRyxZQUFZO1FBQ1ZILE1BQU07SUFDUjtJQUNBSSxlQUFlO1FBQ2JKLE1BQU07SUFDUjtBQUNGIn0=